const defaultDescription = "TEST DESCRIPTION"

export const BRAND_SLUG = "InstoreX"

export const METADATA = {
  HOME: {
    title: "InstoreX | Home",
    description: defaultDescription
  },
  COMMERCIALSUBSCRIPTION: {
    title: "InstoreX | Commercial Subscription",
    description: defaultDescription
  },
  SUCCESSFULCHECKOUT: {
    title: "InstoreX | Successful Checkout",
    description: defaultDescription
  },
  TERMSOFSERVICE: {
    title: "InstoreX | Terms of Service",
    description: defaultDescription
  },
  PRIVACYINFO: {
    title: "InstoreX | Privacy Info",
    description: defaultDescription
  },
  COMMERCIALSUBSCRIPTIONLOGIN: {
    title: "InstoreX | Login",
    description: defaultDescription
  },
  COMMERCIALSUBSCRIPTIONSIGNUP: {
    title: "InstoreX | Signup",
    description: defaultDescription
  },
  COMMERCIALSUBSCRIPTIONDASHBOARD: {
    title: "InstoreX | Dashboard",
    description: defaultDescription
  },
  DASHBOARD: {
    title: "InstoreX | Dashboard",
    description: defaultDescription
  },
  HANDLETAGS: {
    title: "InstoreX | Handle Tags",
    description: defaultDescription
  },
  KONTAKT: {
    title: "InstoreX | Kontakt",
    description: defaultDescription
  },
  LIVECONTENT: {
    title: "InstoreX | Live Content",
    description: defaultDescription
  },
  LOGIN: {
    title: "InstoreX | Login",
    description: defaultDescription
  },
  LYDBRANDING: {
    title: "InstoreX | Lydbranding",
    description: defaultDescription
  },
  MUSICMIND: {
    title: "InstoreX | Musicmind",
    description: defaultDescription
  },
  PLAYLIST: {
    title: "InstoreX | Playlist",
    description: defaultDescription
  },
  TAGGEDCONTENT: {
    title: "InstoreX | Tagged Content",
    description: defaultDescription
  },
  TAGGEDPLAYLIST: {
    title: "InstoreX | Tagged Playlist",
    description: defaultDescription
  },
  UNITS: {
    title: "InstoreX | Units",
    description: defaultDescription
  },
  UPLOADCONTENT: {
    title: "InstoreX | Upload Content",
    description: defaultDescription
  },
  MUSIC: {
    title: "InstoreX | Music Content",
    description: defaultDescription
  },
  PRESENTATIONS: {
    title: "InstoreX | Presentations",
    description: defaultDescription
  },
  DYNAMICPLAYLIST: {
    title: "InstoreX | Dynamic Playlist",
    description: defaultDescription
  },
  MUSIK: {
    title: "InstoreX | Musik",
    description: defaultDescription
  },
  SIGNAGE: {
    title: "InstoreX | Signage",
    description: defaultDescription
  },
  ABOUTUS: {
    title: "InstoreX | About Us",
    description: defaultDescription
  },
}